import { buildCompanyHeaders, getStoredCompanyId } from "./companyWorkspace";

export function buildDataMigrationFormData(
  file,
  step,
  options = {},
  token = ""
) {
  const data = new FormData();
  data.append("file", file);
  data.append("filename", file.name);
  data.append("step", step);
  data.append("source", options.source || "inspal");
  if (options.userRole) data.append("userRole", options.userRole);
  if (options.userType) data.append("userType", options.userType);
  if (options.batchSize) data.append("batchSize", String(options.batchSize));
  if (token) data.append("token", token);
  return data;
}

export function buildDataMigrationAuthHeaders(token = "") {
  const headers = token ? { "x-access-token": token } : {};
  return buildCompanyHeaders(headers, getStoredCompanyId());
}

export async function downloadMigrationTemplate({
  serverUrl,
  file,
  step,
  options = {},
  token = "",
  fetchImpl = fetch,
}) {
  const data = buildDataMigrationFormData(file, step, options, token);
  const response = await fetchImpl(`${serverUrl}/dataMigration/generateTemplate`, {
    method: "POST",
    headers: buildDataMigrationAuthHeaders(token),
    body: data,
  });

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok || contentType.includes("application/json")) {
    let message = `Template download failed (${response.status || "unknown"})`;
    try {
      const body = await response.json();
      message = body?.message || body?.error?.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }

  return response.blob();
}

export async function postDataMigrationForm({
  serverUrl,
  endpoint,
  file,
  step,
  options = {},
  token = "",
  fetchImpl = fetch,
}) {
  const data = buildDataMigrationFormData(file, step, options, token);
  const response = await fetchImpl(`${serverUrl}/dataMigration/${endpoint}`, {
    method: "POST",
    headers: buildDataMigrationAuthHeaders(token),
    body: data,
  });
  return response.json();
}

export async function listMigrationBatches({
  serverUrl,
  token = "",
  page = 1,
  pageSize = 20,
  source = "inspal",
  step = "",
  status = "",
  fetchImpl = fetch,
}) {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    source,
  });
  if (step && step !== "all") params.set("step", step);
  if (status && status !== "all") params.set("status", status);
  const response = await fetchImpl(
    `${serverUrl}/dataMigration/batches?${params}`,
    {
      method: "GET",
      headers: buildDataMigrationAuthHeaders(token),
    }
  );
  return response.json();
}

export async function getMigrationBatchRows({
  serverUrl,
  batchId,
  token = "",
  page = 1,
  pageSize = 25,
  errorsOnly = false,
  fetchImpl = fetch,
}) {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    errorsOnly: String(Boolean(errorsOnly)),
  });
  const response = await fetchImpl(
    `${serverUrl}/dataMigration/batch/${batchId}/rows?${params}`,
    {
      method: "GET",
      headers: buildDataMigrationAuthHeaders(token),
    }
  );
  return response.json();
}

export async function stopMigrationBatch({
  serverUrl,
  batchId,
  token = "",
  fetchImpl = fetch,
}) {
  const response = await fetchImpl(
    `${serverUrl}/dataMigration/batch/${batchId}/stop`,
    {
      method: "POST",
      headers: buildDataMigrationAuthHeaders(token),
    }
  );
  return response.json();
}

export async function undoMigrationBatch({
  serverUrl,
  batchId,
  token = "",
  fetchImpl = fetch,
}) {
  const response = await fetchImpl(
    `${serverUrl}/dataMigration/batch/${batchId}/undo`,
    {
      method: "POST",
      headers: buildDataMigrationAuthHeaders(token),
    }
  );
  return response.json();
}
